import secureStorage from '@/utils/secureStorage';
import { type User } from '@/store/user/store';

const EMPTY_USER: User = { id: null, email: null, firstName: null, lastName: null };

export function getUser(): User {
  try {
    const raw = secureStorage.getItem('user-store');
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed?.state?.user ?? EMPTY_USER;
  } catch {
    return EMPTY_USER;
  }
}

export function getUserEmail(): string | null {
  return getUser()?.email ?? null;
}
